/*
 * Scroll reveal for the Foshylicious custom sections.
 *
 * Elements start visible and are hidden by this script, so a JS failure leaves
 * the page readable rather than blank. Items animate in sequence: the first
 * screen gets a short entrance after load, and later sections cascade as they
 * scroll into view.
 */
(function () {
  var TARGETS = [
    '.hero-banner__rating',
    '.hero-banner__heading',
    '.hero-banner__text',
    '.hero-banner__button',
    '.hero-banner__stat',
    '.feature-icons__item',
    '.about-us__eyebrow',
    '.about-us__title',
    '.about-us__subtitle',
    '.about-us__heading',
    '.about-us__product',
    '.about-us__tag',
    '.best-sellers__head',
    '.best-sellers__card',
    '.services__media',
    '.services__eyebrow',
    '.services__heading',
    '.services__item',
    '.our-product__head',
    '.our-product__card',
    '.promo-banner__eyebrow',
    '.promo-banner__heading',
    '.promo-banner__text',
    '.promo-banner__button',
    '.promo-banner__media',
    '.testimonials__head',
    '.testimonials__card',
    '.why-choose__eyebrow',
    '.why-choose__heading',
    '.why-choose__stat',
    '.why-choose__image',
    '.why-choose__divider',
    '.why-choose__button',
    '.why-choose__monogram',
    '.product-details__media',
    '.product-details__title',
    '.product-details__price',
    '.product-details__rating',
    '.product-details__description',
    '.product-details__form',
    '.product-details__tabs',
    '.product-details__thumb',
    '.footer-brand__top',
    '.footer-brand__bottom'
  ].join(',');

  var STAGGER_MS = 120;
  var MAX_STAGGER_STEPS = 6;
  var LOAD_DELAY_MS = 200;
  var ENTRANCE_WINDOW_MS = 800;
  // Must stay in step with the transition duration in reveal.css
  var TRANSITION_MS = 900;
  // How long after scrolling stops before the safety sweep runs. Long enough
  // that the observer has had every chance to handle it on the normal path.
  var SWEEP_DELAY_MS = 700;

  // Once an element has animated in, drop the transition again. Leaving it
  // attached keeps every revealed element a live animation candidate, which the
  // compositor has to account for on each scroll frame — with dozens of them on
  // a page that shows up as tearing while scrolling.
  function scheduleCleanup(el) {
    var delay = parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0;
    setTimeout(function () {
      el.classList.remove('reveal-target');
      el.style.removeProperty('--reveal-delay');
    }, delay + TRANSITION_MS + 120);
  }

  function start() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var elements = document.querySelectorAll(TARGETS);
    if (!elements.length) return;

    var startedAt = Date.now();
    var entranceCount = 0;

    var observer = new IntersectionObserver(
      function (entries) {
        // Anything already on screen at load is an "entrance": hold briefly, then
        // cascade top to bottom so the first screen animates instead of appearing
        // pre-revealed. Entries arrive in arbitrary order, so sort by position.
        var isEntrance = Date.now() - startedAt < ENTRANCE_WINDOW_MS;
        var visible = entries.filter(function (entry) {
          return entry.isIntersecting;
        });

        if (isEntrance) {
          visible.sort(function (a, b) {
            return a.boundingClientRect.top - b.boundingClientRect.top;
          });
        }

        visible.forEach(function (entry) {
          if (isEntrance) {
            var step = Math.min(entranceCount, MAX_STAGGER_STEPS);
            entry.target.style.setProperty(
              '--reveal-delay',
              LOAD_DELAY_MS + step * STAGGER_MS + 'ms'
            );
            entranceCount = entranceCount + 1;
          }
          entry.target.classList.remove('reveal-hidden');
          observer.unobserve(entry.target);
          scheduleCleanup(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    var seenParents = [];
    var parentCounts = [];
    var pending = [];

    Array.prototype.forEach.call(elements, function (el) {
      // The pinned testimonials row is already driven by scroll position —
      // a second transform on its cards fights that.
      if (el.closest('.testimonials--pinned') && !el.classList.contains('testimonials__head')) return;
      if (el.closest('[data-no-reveal]')) return;

      // Elements arrive in document order, so an ancestor is already marked by
      // the time we reach its children. Nesting reveals compounds the transforms
      // and reads as mushy, so let the outermost one carry the animation.
      if (el.parentElement && el.parentElement.closest('.reveal-target')) return;

      var parent = el.parentNode;
      var index = seenParents.indexOf(parent);
      if (index === -1) {
        seenParents.push(parent);
        parentCounts.push(0);
        index = seenParents.length - 1;
      }
      var order = Math.min(parentCounts[index], MAX_STAGGER_STEPS);
      parentCounts[index] = parentCounts[index] + 1;

      el.classList.add('reveal-target', 'reveal-hidden');
      if (order > 0) el.style.setProperty('--reveal-delay', order * STAGGER_MS + 'ms');

      pending.push(el);
    });

    if (!pending.length) return;

    function reveal(el) {
      el.classList.remove('reveal-hidden');
      observer.unobserve(el);
      scheduleCleanup(el);
    }

    // The observer's first callback can land before the browser has painted the
    // hidden state. Going 0 -> 1 inside one task coalesces at style recalc and
    // no transition runs — the element simply appears. Forcing a reflow and
    // waiting two frames guarantees opacity:0 is painted before anything moves.
    document.body.offsetHeight;

    var begun = false;

    function begin() {
      if (begun) return;
      begun = true;
      startedAt = Date.now();
      pending.forEach(function (el) {
        observer.observe(el);
      });
      scheduleSweep();
    }

    // Safety net for anything the observer never reports. Hiding an element is
    // only safe while something is guaranteed to unhide it, and the footer is
    // where that guarantee runs out: it is the last thing on the page, so once
    // it settles inside the observer's bottom margin there is no scrolling left
    // to move it back out and trigger a callback. It stays at opacity 0 for
    // good — which is the exact failure the top of this file says cannot happen.
    //
    // So sweep once scrolling settles and reveal anything that is plainly on
    // screen but still hidden. The observer normally gets there within a frame,
    // so in the healthy case this finds nothing.
    var sweepTimer = null;

    function sweep() {
      var stillHidden = [];

      pending.forEach(function (el) {
        if (!el.classList.contains('reveal-hidden')) return;

        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) reveal(el);
        else stillHidden.push(el);
      });

      pending = stillHidden;

      if (!pending.length) {
        window.removeEventListener('scroll', scheduleSweep);
        window.removeEventListener('resize', scheduleSweep);
      }
    }

    function scheduleSweep() {
      if (sweepTimer) clearTimeout(sweepTimer);
      sweepTimer = setTimeout(sweep, SWEEP_DELAY_MS);
    }

    window.addEventListener('scroll', scheduleSweep, { passive: true });
    window.addEventListener('resize', scheduleSweep);

    requestAnimationFrame(function () {
      requestAnimationFrame(begin);
    });

    // requestAnimationFrame does not run in a background tab. Without this
    // fallback, a page opened in one would sit at opacity 0 with nothing
    // observing it — content hidden permanently, which is the one failure this
    // script is built to avoid.
    setTimeout(begin, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
